// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/precipitation-formation-processes.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/precipitation-formation-processes/precipitation-formation-processes.js';

mount([g0]);
